export default "__VITE_ASSET__d36e597e__"